import React from 'react';

// Import route modules
import { publicRoutes } from './routes/public-routes';
import { serviceRoutes } from './routes/service-routes';
import { locationRoutes } from './routes/location-routes';
import { authRoutes } from './routes/auth-routes';
import { portalRoutes } from './routes/portal-routes';
import { testRoutes } from './routes/test-routes';

// Import SEO routes (programmatically generated)
import { seoRoutesFixed } from './routes/seo-routes-fixed';

// Client portal routes will be added when new client portal is built (PCM-011)

interface RouteConfig {
  path?: string;
  element?: React.ReactNode;
  children?: RouteConfig[];
}

// Combine all routes
export const routes: RouteConfig[] = [
  // Public pages
  ...publicRoutes,

  // Service pages
  ...serviceRoutes,

  // Location pages
  ...locationRoutes,

  // Authentication
  ...authRoutes,

  // Staff/Admin portal
  ...portalRoutes,

  // Test routes (can be disabled in test-routes.tsx)
  ...testRoutes,

  // SEO routes (programmatically generated location/industry pages)
  ...seoRoutesFixed,
];
